import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AppShell, CardPanel, StatusCheckCard } from "../components";
import { clearClientSession } from "../config/auth";

const SubmissionPage = () => {
  const navigate = useNavigate();
  const [studentName, setStudentName] = useState("Friend");

  useEffect(() => {
    const name = localStorage.getItem("student_name");

    if (name && name.trim()) {
      const firstName = name.trim().split(" ")[0];
      setStudentName(firstName || "Friend");
    }
  }, []);

  const handleAskAgain = () => {
    navigate("/QuestionPage");
  };

  return (
    <AppShell logoPosition="bottom">
      <CardPanel className="ui-card-panel--wide">
        <StatusCheckCard
          title={
            <>
              Dear <strong>{studentName}</strong>,
            </>
          }
          subtitle="Thank you for your submission"
          description={
            <>
              Your question was successfully sent and we will get back
              <br />
              to you with an answer via Email
            </>
          }
          actionLabel="Ask Another Question"
          onAction={handleAskAgain}
          actionVariant="danger"
        />
      </CardPanel>
    </AppShell>
  );
};

export default SubmissionPage;
